// Configurações de ambiente
export const config = {
  // URL da API TANDER
  API_URL: import.meta.env.VITE_API_URL || 'https://tnd-image-1010207941530.us-west1.run.app',
  
  // Nome e versão da aplicação
  APP_NAME: import.meta.env.VITE_APP_NAME || 'TANDER',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  
  // Configurações de pagamento (para desenvolvimento)
  PAGARME_PUBLIC_KEY: import.meta.env.VITE_PAGARME_PUBLIC_KEY || 'pk_test_123456789',
  PAGARME_ENCRYPTION_KEY: import.meta.env.VITE_PAGARME_ENCRYPTION_KEY || 'ek_test_123456789',
  
  // Configurações de segurança
  TOKEN_STORAGE_KEY: 'tander_auth_token',
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000, // 24 horas em milissegundos
  
  // URLs externas
  WHATSAPP_URL: 'https://wa.me/5511999999999',
  SUPPORT_EMAIL: 'tandersmart@tandersolucoes.com.br',
  
  // Configurações de UI
  ANIMATION_DURATION: 300,
  DEBOUNCE_DELAY: 300,
  
  // Limites de validação
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_FILE_COUNT: 10,
  ALLOWED_FILE_TYPES: ['.pdf', '.doc', '.docx', '.txt', '.jpg', '.jpeg', '.png'],
}

// Validação de ambiente
export const validateEnvironment = () => {
  const required = ['API_URL']
  const missing = required.filter(key => !config[key as keyof typeof config])
  
  if (missing.length > 0) {
    console.warn(`Configurações de ambiente ausentes: ${missing.join(', ')}`)
  }
  
  return missing.length === 0
}

// Configurações específicas por ambiente
export const isDevelopment = import.meta.env.DEV
export const isProduction = import.meta.env.PROD
export const isTest = import.meta.env.MODE === 'test'

// Configurações de debug
export const debug = {
  enabled: isDevelopment,
  logLevel: isDevelopment ? 'debug' : 'error',
  showApiCalls: isDevelopment,
  showValidationErrors: isDevelopment,
}

